import { put, takeEvery, select } from 'redux-saga/effects';
import actions from './actions';
import analyticsActions from '../actions';

function setConfig() {
  window.utag_cfg_ovrd = {
    noview: true,
  };
}

function* jqueryInit() {
  try {
    if (window.jQuery) {
      yield setConfig();
      yield put(actions.initSuccess());
    } else {
      throw new Error('jquery is not available.');
    }
  } catch (e) {
    yield put(actions.initFailed(e));
  }
}

function* jquerySendScreenview({ payload }) {
  const { analytics, page, refs, ui } = yield select();

  if (analytics.jquery) {
    try {
      window.jQuery(document.body).trigger('OAOAnalyticsEventFired', {
        app_ids: refs.appIds || '',
        app_name: 'OAO',
        app_request_id: refs.appRequestId || '',
        app_version: window.version || '',
        event: 'page_view',
        market: refs.market || '',
        oao_group_name: ui.activeGroup || '',
        oao_page_name: page.name || '',
        page_type: payload || '',
        product: refs.product || '',
        refs,
        status: refs.status || '',
      });

      yield put(actions.sendScreenviewSuccess(payload));
    } catch (e) {
      yield put(actions.sendScreenviewFailed(e));
    }
  }
}

function* jquerySendEvent({ payload, type }) {
  const { analytics, page, refs, ui } = yield select();
  const { activeGroup } = ui;

  if (analytics.jquery) {
    try {
      const { eventCategory, eventLabel } = payload;

      window.jQuery(document.body).trigger('OAOAnalyticsEventFired', {
        app_ids: refs.appIds || '',
        app_name: 'OAO',
        app_request_id: refs.appRequestId || '',
        app_version: window.version || '',
        event: type.toLowerCase(),
        event_action: eventCategory || '',
        event_category: eventCategory || '',
        event_label: eventLabel || '',
        market: refs.market || '',
        oao_group_name: activeGroup || '',
        oao_page_name: page.name || '',
        product: refs.product || '',
        refs,
        status: refs.status || '',
        tealium_event: type.toLowerCase(),
      });

      yield put(actions.sendEventSuccess(type));
    } catch (e) {
      yield put(actions.sendEventFailed(e));
    }
  }
}

export default [
  takeEvery(analyticsActions.ANALYTICS_INIT, jqueryInit),
  takeEvery(analyticsActions.ANALYTICS_SEND_SCREENVIEW, jquerySendScreenview),
  takeEvery(
    [
      analyticsActions.FIELD_BLUR,
      analyticsActions.FIELD_ERROR,
      analyticsActions.GOOGLE_PLACES_AUTOCOMPLETE,
      analyticsActions.GROUP,
      analyticsActions.GROUP_NAV,
      analyticsActions.GROUP_SUBMIT,
      analyticsActions.GROUP_SUBMIT_ERROR,
      analyticsActions.GROUP_SUBMIT_SUCCESS,
      analyticsActions.PAGE,
      analyticsActions.PAGE_NAV,
      analyticsActions.PAGE_SUBMIT,
      analyticsActions.PAGE_SUBMIT_ERROR,
      analyticsActions.PAGE_SUBMIT_SUCCESS,
      analyticsActions.SERVER_ERROR,
      analyticsActions.START,
      analyticsActions.TIMEOUT,
      analyticsActions.TIMEOUT_WARNING,
      analyticsActions.TOOLTIP_VIEW,
      analyticsActions.WORKFLOW_END,
    ],
    jquerySendEvent,
  ),
];
